import React, {useEffect, useState} from 'react';
import {FaBars, FaChevronDown, FaFacebookF, FaInstagram, FaSignOutAlt, FaTimes, FaTwitter} from "react-icons/fa";
import SideMenu from './SideMenu';
import {useAuth} from '../../context/AuthContext';
import {useNavigate, Link} from "react-router-dom";
import {ShowWhenAuthenticated, HideWhenAuthenticated} from '../../context/AuthContext';
import GoogleTranslate from '../common/GoogleTranslate';

const HeaderTop = () => {
    const [isFixed, setIsFixed] = useState(false);
    const [isHeaderTopVisible, setIsHeaderTopVisible] = useState(true);
    const [isMenuVisible, setIsMenuVisible] = useState(false);
    const [isSubMenuVisible, setIsSubMenuVisible] = useState(false);
    const [isSideMenuVisible, setIsSideMenuVisible] = useState(false);

    const {isAuthenticated, user, logout} = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate('/');
    };

    useEffect(() => {
        const handleScroll = () => {
            const header = document.querySelector('.header-section');
            if (header) {
                const currentScrollY = window.scrollY;

                if (currentScrollY === 0) {
                    setIsHeaderTopVisible(true);
                    setIsFixed(false);
                } else {
                    setIsHeaderTopVisible(false);
                    setIsFixed(true);
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const toggleMenu = () => {
        setIsMenuVisible(!isMenuVisible);
    };

    const toggleSubMenu = () => {
        setIsSubMenuVisible(!isSubMenuVisible);
    };

    const toggleSideMenu = () => {
        setIsSideMenuVisible(!isSideMenuVisible);
    };

    return (
        <>
            {/* Section header-top-section */}
            {isHeaderTopVisible && (
                <section className="header-top-section overflow-visible p1-bg py-3">
                    <div className="container">
                        <div
                            className="d-sm-flex d-grid gap-sm-0 gap-2 align-items-center justify-content-sm-between justify-content-center">
                            <div className="d-flex align-items-center gap-2 fs-eight n0-clr">
                                <a style={{color: '#fff'}} href="https://www.google.com/maps/place/Montréal,+QC/"
                                   target="_blank">
                                    <i className="fa-solid fa-location-dot"></i> Yaoundé, Cameroun
                                </a>
                                <span className="fs-eight n0-clr"> Tél : +237 6 74 69 85 18</span>
                            </div>

                            <div
                                className="d-flex align-items-center justify-content-sm-start justify-content-center gap-lg-6">
                                {/* ── Sélecteur de langue Google Translate ── */}
                                <div className="d-flex align-items-center me-3">
                                    <GoogleTranslate/>
                                </div>

                                <div className="d-flex align-items-center gap-2">
                                    <span className="fs-eight n0-clr"> Suivez-nous :</span>
                                    <div className="social d-flex align-items-center gap-xxl-3 gap-2">
                                        <a
                                            href="https://www.facebook.com/share/18b9UsguLn/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="n0-clr"
                                        >
                                            <FaFacebookF/>
                                        </a>

                                        <a
                                            href="https://www.instagram.com/drivenhomeservices/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="n0-clr"
                                        >
                                            <FaInstagram/>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            )}

            {/* Header principal */}
            <header
                className="header-section header-style4"
                style={{
                    position: isFixed ? 'fixed' : 'relative',
                    top: isFixed ? 0 : 'auto',
                    left: 0,
                    width: '100%',
                    zIndex: isFixed ? 1000 : 'auto',
                    backgroundColor: isFixed ? 'white' : 'transparent',
                    boxShadow: isFixed ? '0 2px 5px rgba(0, 0, 0, 0.1)' : 'none',
                    transition: 'all 0.3s ease',
                }}
            >
                <div className="container">
                    <div className="main-navbar">
                        <nav className="navbar-custom">
                            <div className="d-flex align-items-center justify-content-between w-100">

                                {/* ── Zone MOBILE (visible uniquement sur sm et moins) ── */}
                                <div
                                    className="d-flex d-md-none align-items-center w-100 p-2"
                                    style={{gap: '8px'}}
                                >
                                    {/* Bouton hamburger (seulement si authentifié) */}
                                    <ShowWhenAuthenticated>
                                        <button
                                            onClick={toggleSideMenu}
                                            style={{
                                                background: 'none',
                                                border: 'none',
                                                cursor: 'pointer',
                                                padding: '8px',
                                                zIndex: 998,
                                                flexShrink: 0,
                                            }}
                                        >
                                            <FaBars style={{width: '24px', height: '24px', color: '#000'}}/>
                                        </button>
                                    </ShowWhenAuthenticated>

                                    {/* Logo centré */}
                                    <Link to="/" className="nav-brand" style={{flexShrink: 0}}>
                                        <img
                                            src="assets/images/logo/logo.png"
                                            alt="logo"
                                            style={{width: '50px', height: '50px', borderRadius: '50%'}}
                                        />
                                    </Link>

                                    {/* Bouton toggle menu (seulement si NON authentifié) */}
                                    <HideWhenAuthenticated>
                                        <button
                                            className="navbar-toggle-btn"
                                            type="button"
                                            onClick={toggleMenu}
                                            style={{
                                                marginLeft: 'auto',
                                                background: 'none',
                                                border: 'none',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            {isMenuVisible ? (
                                                <FaTimes style={{width: '28px', height: '28px', cursor: 'pointer'}}/>
                                            ) : (
                                                <FaBars style={{width: '28px', height: '28px'}}/>
                                            )}
                                        </button>
                                    </HideWhenAuthenticated>

                                    {/* Bouton DÉCONNEXION — toujours à droite sur mobile */}
                                    {isAuthenticated && (
                                        <button
                                            onClick={handleLogout}
                                            className="dhs-btn overflow-hidden n0-clr d-inline-flex align-items-center gap-2 text-capitalize bg-danger fw-500"
                                            title="Se déconnecter"
                                            style={{
                                                marginLeft: 'auto',
                                                padding: '8px 14px',
                                                fontSize: '13px',
                                                borderRadius: '6px',
                                                border: 'none',
                                                cursor: 'pointer',
                                                whiteSpace: 'nowrap',
                                                flexShrink: 0,
                                            }}
                                        >
                                            <FaSignOutAlt/>
                                            <span>Déconnexion</span>
                                        </button>
                                    )}
                                </div>

                                {/* ── Zone DESKTOP (visible à partir de md) ── */}
                                <div className="d-none d-md-flex align-items-center gap-3 w-100">
                                    <div className="d-flex gap-6">
                                        <div className="switch-wrapper-top d-flex d-lg-none"></div>

                                        <HideWhenAuthenticated>
                                            <button
                                                className="navbar-toggle-btn d-block d-lg-none"
                                                type="button"
                                                onClick={toggleMenu}
                                            >
                                                {isMenuVisible ? (
                                                    <div className="close-icon">
                                                        <FaTimes style={{
                                                            width: '30px',
                                                            height: '40px',
                                                            marginLeft: '0px',
                                                            cursor: 'pointer'
                                                        }}/>
                                                    </div>
                                                ) : (
                                                    <>
                                                        <span></span>
                                                        <span></span>
                                                        <span></span>
                                                        <span></span>
                                                    </>
                                                )}
                                            </button>
                                        </HideWhenAuthenticated>
                                    </div>
                                </div>

                            </div>

                            {/* ── Menu déroulant (desktop lg+) ── */}
                            <div className="navbar-toggle-item" style={{display: isMenuVisible ? 'block' : 'none'}}>
                                <div
                                    className="d-flex w-100 flex-column flex-lg-row align-items-start align-items-lg-center justify-content-between mt-5 mt-lg-0">

                                    <div className="d-none d-lg-flex align-items-center">
                                        <ShowWhenAuthenticated>
                                            <button
                                                onClick={toggleSideMenu}
                                                style={{
                                                    background: 'none',
                                                    border: 'none',
                                                    cursor: 'pointer',
                                                    zIndex: 998,
                                                    padding: '10px',
                                                }}
                                            >
                                                <FaBars style={{width: '24px', height: '24px', color: '#000'}}/>
                                            </button>
                                        </ShowWhenAuthenticated>

                                        <Link to="/" className="navbar-brand ms-2">
                                            <img
                                                className="w-100"
                                                src="assets/images/logo/logo.png"
                                                alt="logo"
                                                style={{width: '60px', height: '60px', borderRadius: '50%'}}
                                            />
                                        </Link>
                                    </div>

                                    <HideWhenAuthenticated>
                                        <ul className="custom-nav d-lg-flex d-grid gap-xxl-6 gap-xl-5 gap-4">
                                            <li className="menu-item position-relative">
                                                <Link to="/" className="n900-clr">
                                                    Accueil
                                                </Link>
                                            </li>

                                            <li className="menu-item position-relative">
                                                <Link to="/professionals" className="n900-clr">
                                                    Professionnels
                                                </Link>
                                            </li>


                                            <li className="menu-item mega-menu-items">
                                                <button
                                                    className="position-relative pe-5 cus-z1"
                                                    onClick={toggleSubMenu}
                                                >
                                                    Nos Services
                                                </button>

                                                <ul
                                                    className="sub-menu sub-mega-menu p-lg-5 box-shadow3"
                                                    style={{display: isSubMenuVisible ? 'block' : 'none'}}
                                                >
                                                    <li className="d-flex justify-content-between gap-3 flex-wrap">

                                                        <ul>
                                                            <li className="mb-lg-5 mb-md-4 mb-3 d-grid">
                                                                <Link
                                                                    to="/menage"
                                                                    className="text-decoration-none"
                                                                >
                                                                    <img
                                                                        src="assets/images/icon/1.png"
                                                                        alt="Aide Ménagère"
                                                                        className="mb-2"
                                                                        style={{height: '80px'}}
                                                                    />

                                                                    <span className="fs20 fw-semibold n900-clr">
                                                                        Aide Ménagère
                                                                    </span>
                                                                </Link>
                                                            </li>
                                                        </ul>


                                                        <ul>
                                                            <li className="mb-lg-5 mb-md-4 mb-3 d-grid">
                                                                <Link
                                                                    to="/baby-sitting"
                                                                    className="text-decoration-none"
                                                                >
                                                                    <img
                                                                        src="assets/images/icon/2.png"
                                                                        alt="Garde d'Enfants"
                                                                        className="mb-2"
                                                                        style={{height: '80px'}}
                                                                    />

                                                                    <span className="fs20 fw-semibold n900-clr">
                                                                        Garde d'Enfants
                                                                    </span>
                                                                </Link>
                                                            </li>
                                                        </ul>


                                                        <ul>
                                                            <li className="mb-lg-5 mb-md-4 mb-3 d-grid">
                                                                <Link
                                                                    to="/aide-domicile"
                                                                    className="text-decoration-none"
                                                                >
                                                                    <img
                                                                        src="assets/images/icon/3.png"
                                                                        alt="Aide aux Personnes Âgées"
                                                                        className="mb-2"
                                                                        style={{height: '80px'}}
                                                                    />

                                                                    <span className="fs20 fw-semibold n900-clr">
                                                                        Aide aux Personnes Âgées
                                                                    </span>
                                                                </Link>
                                                            </li>
                                                        </ul>


                                                        <ul>
                                                            <li className="mb-lg-5 mb-md-4 mb-3 d-grid">
                                                                <Link
                                                                    to="/soutien-scolaire"
                                                                    className="text-decoration-none"
                                                                >
                                                                    <img
                                                                        src="assets/images/icon/4.png"
                                                                        alt="Soutien Scolaire"
                                                                        className="mb-2"
                                                                        style={{height: '80px'}}
                                                                    />

                                                                    <span className="fs20 fw-semibold n900-clr">
                                                                        Soutien Scolaire
                                                                    </span>
                                                                </Link>
                                                            </li>
                                                        </ul>


                                                        {/*
            <ul>
                <li className="mb-lg-5 mb-md-4 mb-3 d-grid">
                    <Link
                        to="/services-quotidien"
                        className="text-decoration-none"
                    >
                        <img
                            src="assets/images/icon/6.png"
                            alt="Services Quotidien"
                            className="mb-2"
                            style={{ height: '80px' }}
                        />

                        <span className="fs20 fw-semibold n900-clr">
                            Services Quotidien
                        </span>
                    </Link>
                </li>
            </ul>
            */}

                                                    </li>
                                                </ul>
                                            </li>


                                            <li className="menu-item position-relative">
                                                <Link to="/contact" className="n900-clr">
                                                    Contactez-nous
                                                </Link>
                                            </li>

                                            <li className="menu-item position-relative">
                                                <Link to="/login" className="n900-clr">
                                                    Connexion
                                                </Link>
                                            </li>
                                        </ul>
                                    </HideWhenAuthenticated>

                                    {/* Bouton déconnexion desktop (dans le menu navbar) */}
                                    {isAuthenticated && (
                                        <button
                                            onClick={handleLogout}
                                            className="dhs-btn overflow-hidden n0-clr d-inline-flex align-items-center gap-2 text-capitalize bg-danger py-xxl-4 py-3 px-xxl-8 px-lg-5 px-4 fw-500"
                                            title="Se déconnecter"
                                        >
                                            <FaSignOutAlt/>
                                            Déconnexion
                                        </button>
                                    )}
                                </div>
                            </div>

                        </nav>
                    </div>
                </div>
            </header>

            {/* Menu latéral */}
            <SideMenu isVisible={isSideMenuVisible} onClose={toggleSideMenu}/>
        </>
    );
};

export default HeaderTop;